<template>
	<div>
	<ppe-form 
		entityName="Company"
	  formkey="b1_eu"
		:title="'B1. FICHE DE PRÉSENTATION EU -'"
		title-field="{name}"
 	  sub-title="Renseignez les informations de votre entité"
		:schema="schema" :endpoint="endpoint"
		:redirect="this.getRedirectUrl()"
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
	</div>
</template>
<script>
import Utils    from '../ppe/utils'
 
export default {
	

	data() {
		return {
			values: {},
			endpoint : this.getApiUrl(),
			schema : [
				{
					card:"Société / Pôle", cardkey:"b1_card_company",
					body:[
						{name:"name",       label:"Nom",     type: "text",     validation: 'required', size:'medium'},
						
						{name:"address",    label:"Adresse", type: "textarea", validation: 'required', size:'large'},

						{name:"zip",        label:"Code postal",             type: "number",   validation: 'required', size:'small'},
						{name:"city",       label:"Ville",                   type: "text",     validation: 'required'},

						{name:"activity",   label:"Activité principale",     type: "text",     validation: 'required'},
						{name:"activity2",  label:"Activité secondaire", 		 type: "text",     validation: ''},

						{name:"siret",   		label:"SIRET",                type: "text",     validation: 'required', size:'small'},
						{name:"ape",   			label:"Code APE",                type: "text",     validation: 'required', size:'small'},
						//{name:"statut",     label:"Statut (SA, SAS, SARL, ..)", type: "text",  validation: 'required', size:'small'},
						//{name:"nbentities", label:"Nombre d'entités", 			 type: "number",   validation: '',         size:'small'},
						{name:"nbemployees",label:"Nombre de personnels",type: "number",  placeholder: 'Nombre',         size:'small'},
						
						{name:"website",    label:"Site web",                type: "text",     validation: '', size:'large'},
						//{component:"div",   },

						{name:"companyOwner.name",   label:"Responsable de l'entité utilisatrice",  type: "text",   validation: 'required',   size: 'Medium'},
						{name:"companyOwner.phone",   label:"Portable",  type: "text",       validation: 'required',  size: 'small'},
						{name:"companyOwner.email",   label:"Email",  type: "text",          validation: 'required',  size: 'small'},
						
						{name:"securityOfficer.name",   label:"Responsable sécurité",  type: "text",     size: 'Medium'},
						{name:"securityOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"securityOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"covidOfficer.name",   label:"Responsable COVID 19",  type: "text",     size: 'Medium'},
						{name:"covidOfficer.phone",   label:"Portable",  type: "text",     size: 'small'},
						{name:"covidOfficer.email",   label:"Email",  type: "text",     size: 'small'},

						{name:"operationOfficer.name",   label:"Responsable des opérations",  type: "text",     validation: 'required',   size: 'Medium'},
						{name:"operationOfficer.phone",   label:"Portable",  type: "text",     validation: 'required',   size: 'small'},
						{name:"operationOfficer.email",   label:"Email",  type: "text",     validation: 'required',   size: 'small'},
					]
				},
				
				Utils.getGetManagerCard(),

				Utils.getAdminCard([
					{component:"ul",    children: [

						{component:"li",    children: [{name:"isHost",     label:"Cette entreprise est l'EU (Entreprise Utilisatrice) ?", 			 type: "checkbox", validation: '', },]},
						{component:"li",    children: [{component:"label",   children:"Sinon c'est une EE (Entreprise Extérieure)", class:"formulate-input-label" },]},
						]
					},
					
					/*{name:"isHost",     label:"Cette entreprise est",   placeholder:""  ,  validation:'required'     ,
                type:'select',   size:'large', options : [
									{value:true,  label:"l'Entreprise Utilisatrice"},
									{value:false, label:"une Entreprise Extérieure"},
                  ] },*/
					//{name:"website",    label:"Nom des entités / établissements / pôles",  type: "text",   size: 'large', placeholder:"ex: 'pôle' ou 'établissement' ou autre"},
				]),

				],

		}
	},

	methods : {
		getCompanyId() {
			console.log("this.$route.query", this.$route.query)
			let companyId 
			if( this.$route.params.companyId) companyId = this.$route.params.companyId
			else companyId = this.$usermanager.user['company.id']
			return companyId
		},
		getRedirectUrl() {
			return "/ppe_eu/home/"+this.$usermanager.user._id
		},
		getApiUrl() {
			if(!this.$route.query.newForUser)
				return "/eu/company?id="+this.getCompanyId()
			else
				return "/eu/company?newForUser="+this.$route.query.newForUser
		},
		onDataLoaded(data) {
			this.values = data.entity
		}
	}

};
</script>
<style>
</style>
 